import { Injectable } from '@angular/core';
import { SagaSettingsService } from '@services/settings';
import { MapToolsService, ToggleTool, ToolBase, ToolName } from '@techwan/map-tools';
import { Observable, Subscription } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ILocalizeRequest } from '../../../schema/interfaces/ILocalizeRequest';
import { LocalizePositionService } from '../../localize-position/localize-position.service';
import { MyLocationService } from '../../my-location/my-location.service';
import { PositionLayerService } from '../../position-layer/position-layer.service';

@Injectable({
  providedIn: 'root'
})
export class MyLocationButtonsControllerService {
  private subs: Subscription[] = [];

  constructor(
    private mapToolsService: MapToolsService,
    private sagaSettings: SagaSettingsService,
    private myLocationService: MyLocationService,
    private localizePositionService: LocalizePositionService,
    private positionLayerService: PositionLayerService
  ) {}

  init() {
    this.subs.push(
      this.localizePositionService.listenForLocation(
        (this.mapToolsService.getTool(ToolName.LocalizeMe) as ToolBase).$event.pipe(
          switchMap(() => this.createLocalizeRequestForMyPosition())
        )
      )
    );

    const myUnitZoomLevel: number = this.sagaSettings.getValue('SagaMobileWebClient.MyUnitZoomLevel');
    this.subs.push(
      this.localizePositionService.listenForLocation(
        (this.mapToolsService.getTool(ToolName.ZoomMe) as ToolBase).$event.pipe(
          switchMap(() => this.createLocalizeRequestForMyPosition(myUnitZoomLevel))
        )
      )
    );

    const followMeTool: ToggleTool = this.mapToolsService.getTool(ToolName.FollowMe) as ToggleTool;
    this.positionLayerService.setFollowMe(followMeTool.isActive);
    this.subs.push(
      followMeTool.$event.subscribe(tool => {
        this.positionLayerService.setFollowMe(tool.isActive);
      })
    );
  }

  private createLocalizeRequestForMyPosition(zoom: number = -1): Observable<ILocalizeRequest> {
    return this.myLocationService.getCurrent().pipe(
      map(coordinate => {
        return { coordinates: [coordinate], target: null, zoom };
      })
    );
  }

  uninit() {
    while (this.subs.length > 0) {
      this.subs.pop().unsubscribe();
    }
  }
}
